import React, { Fragment } from 'react';
import { Transition } from '@headlessui/react';
import { CheckCircleIcon, ExclamationIcon, XCircleIcon, InformationCircleIcon } from '@heroicons/react/outline';

import { XIcon } from '@heroicons/react/solid';
import Button from '../../TailwindComponents/buttons/Button';

const getIcon = (type) => {
  switch (type) {
    case 'error':
      return <XCircleIcon className="h-6 w-6 text-danger-500" aria-hidden="true" />;
    case 'success':
      return <CheckCircleIcon className="h-6 w-6 text-success-500" aria-hidden="true" />;
    case 'warning':
      return <ExclamationIcon className="h-6 w-6 text-warning-400" aria-hidden="true" />;
    case 'info':
      return <InformationCircleIcon className="h-6 w-6 text-info-400" aria-hidden="true" />;
    default:
      return null;
  }
};

const Notification = ({ type, data, show, setShow, t }) => {
  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="fixed inset-0 z-50 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
        <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={show}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="shrink-0">{getIcon(type)}</div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <div className="text-sm font-medium text-neutro-900">{data.title}</div>
                    {data.text && <div className="mt-1 text-sm text-neutro-500">{data.text}</div>}
                    {data.footer}
                    {data.buttons && (
                      <div className="mt-2 flex gap-2">
                        {data.buttons.map((button) => (
                          <Button
                            {...button.props}
                            key={button.label}
                            size="small"
                            onClick={() => {
                              button.onClick();
                              setShow(false);
                            }}>
                            {button.label}
                          </Button>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="ml-4 shrink-0 flex">
                    <button
                      className="bg-white border-none rounded-md inline-flex text-neutro-400 hover:text-neutro-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={() => {
                        setShow(false);
                      }}>
                      <span className="sr-only">{t('CLOSE')}</span>
                      <XIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
};

export default Notification;
